import { createContext, ReactNode } from 'react';
import { POPULATION_KEY, USER_API_KEY_KEY } from '../config/constants';
import useAuth from '../hooks/useAuth';
import useUserLocalStorage from '../hooks/useUserLocalStorage';
import Population from '../types/population';
import { ValueOrFunction } from '../types/types';

interface UserDataContextType {
  population: Population | undefined;
  setPopulation: ValueOrFunction<Population | undefined>;
  apiKey: string | undefined;
  setApiKey: ValueOrFunction<string | undefined>;
  userDataIsReady: boolean;
}

export const UserDataContext = createContext<UserDataContextType | undefined>(undefined);

export function UserDataProvider({ children }: { children: ReactNode }) {
  const { username } = useAuth();

  // the data (and selected/unselected state) for the population
  const [population, setPopulation, populationIsReady] =
    useUserLocalStorage<Population | undefined>(username, POPULATION_KEY, undefined);

  // optional user-uploaded OpenAI API keyboard
  const [apiKey, setApiKey, apiKeyIsReady] =
    useUserLocalStorage<string | undefined>(username, USER_API_KEY_KEY, undefined);
  
  const userDataIsReady = populationIsReady && apiKeyIsReady;

  return (
    <UserDataContext.Provider
      value={{
        population, setPopulation, apiKey, setApiKey, userDataIsReady
      }}>
      {children}
    </UserDataContext.Provider>
  );
}

